export const localKeyGenByVedaKeysOfChooseImageField = 'KeyGenByVedaKeysOfChooseImageField';
